import {Model} from '@vuex-orm/core';
import UnitPlan from '@/store/units/UnitPlan';
import {IUnitPlanSkill} from '@/interfaces/planner/purpose/IUnitPlanSkill';

// @ts-ignore
export default class UnitPlanSkill extends Model implements IUnitPlanSkill {
    static entity = 'unit_plan_skills';

    static fields () {
        return {
            id: this.number(0),
            skill_id: this.number(null),
            unitplan_id: this.number(null),
            created_at: this.string(new Date().toISOString().substr(0, 10)),
            update_at: this.string(new Date().toISOString().substr(0, 10)),

            skill: this.hasOne('', 'id'),
            unitplan: this.belongsTo(UnitPlan, 'unitplan_id'),
        };
    }
}
